import {Component} from 'react';
import './GameViews/gamePhase2.css';
import SpinnerLegendCard from './spinner_legend_card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';

class SpinnerLegend extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayLegend: true,
        };
    }
    
    toggleLegend(){
        this.setState({displayLegend: !this.state.displayLegend});
    }

   
    render() {
        this.spinnerLegend = this.props.eventCategories.map((eventList, index) =>
            <SpinnerLegendCard key={index} legendInfo={eventList} 
                jobName={this.props.jobName}/>
        );
        this.titleClass = "font-weight-bold gameView-text-size";
        this.legendClass = "legend-position legend-background-color z-index-on-top"
        
             
    return <>
       <span>
            {this.state.displayLegend ?
                <div className={this.legendClass}> 
                    <div className={this.titleClass}>
                        Nbr of Spins in Turn: &nbsp; {this.props.nbrSpins}
                    </div>
                    <div className="small-text-size font-weight-bold text-center">
                        SpinnerLegend &nbsp;&nbsp;
                        <FontAwesomeIcon icon={faCaretDown} 
                            onClick={() => this.toggleLegend()}/> </div>
                            <table>
                                <tbody>
                                    {this.spinnerLegend}
                                </tbody>
                            </table>
                    </div>
            :
                    <div className={this.legendClass}>
                        <div className={this.titleClass}>Number of Spins in Turn: &nbsp;
                             {this.props.nbrSpins}</div>
                        <div className="small-text-size font-weight-bold text-center">
                            Spinner Legend&nbsp;&nbsp;
                            <FontAwesomeIcon icon={faCaretRight}
                                onClick={() => this.toggleLegend()} /> 
                        </div>
                    </div>
            }
        </span>
    </>
    }

}

export default SpinnerLegend;